export const JEECG_TOKEN = 'X-Access-Token'
export const BLOCK_DESIGN_TOKEN = 'X-BD-Access-Token'
export const USER_ID = 'USER_ID'
export const REDIRECT_URL = 'REDIRECT_URL'
export const USER_NAME = 'USER_NAME'

export const PAGE_UNDO_PREFIX = 'PAGE_UNDO_'
export const PAGE_REDO_PREFIX = 'PAGE_REDO_'
export const ACCOUNT_INFO = 'ACCOUNT_INFO'